// extracted by mini-css-extract-plugin
export var close = "styles-module--close--b1130";
export var content = "styles-module--content--c4407";
export var header = "styles-module--header--29d0b";
export var link = "styles-module--link--b4b85";
export var sources = "styles-module--sources--fa544";
export var wrapper = "styles-module--wrapper--91f72";